import I18n from '../i18n';
import React from 'react';

export const EgbButton = (props: {name: string}): React.ReactElement => <div className="button-adaptive button-adaptive_full-thin">
    <span className="button-name">
        {I18n.t(`${props.name}`)}
    </span>
</div>;
